import { render, staticRenderFns } from "./NewPoweredBy.vue?vue&type=template&id=66c26bd7"
import script from "./NewPoweredBy.vue?vue&type=script&lang=js"
export * from "./NewPoweredBy.vue?vue&type=script&lang=js"
import style0 from "./NewPoweredBy.vue?vue&type=style&index=0&id=66c26bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports